import { Loading } from "app/components";
import axios from "axios";
import jwtDecode from "jwt-decode";
import { apiUrl } from "config.js";
import { useSnackbar } from "notistack";
import { createContext, useEffect, useReducer } from "react";

const initialState = {
  user: null,
  error:{isError:false},
  isInitialised: false,
  isAuthenticated: false,
  isPanFetched: false,
};

const isValidToken = (accessToken) => {
  if (!accessToken) return false;

  const decodedToken = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;
  return decodedToken.exp > currentTime;
};

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem("accessToken");
    delete axios.defaults.headers.common.Authorization;
  }
};

const reducer = (state, action) => {
  switch (action.type) {
    case "INIT": {
      const { isAuthenticated, user } = action.payload;
      return { ...state, user, isAuthenticated, isInitialised: true };
    }

    case "PAN_FETCHED" : {
      const {user} = action.payload;
      return {...state, user, error:{isError:false},  isPanFetched:true}
    }
    case "LOGIN": {
      const { user } = action.payload;
      return { ...state, user, isAuthenticated: true };
    }

    case "AUTH_STATUS": {
      const { isAuthenticated, user } = action.payload;
      console.log(isAuthenticated, user)
      return { ...state, user, isAuthenticated: true, isInitialised:true };
    }

    case "LOGOUT": {
      return { ...state, isAuthenticated: false, isPanFetched:false, user: null };
    }
    case "REGISTER": {
      const { user } = action.payload;
      return { ...state, isAuthenticated: true, user };
    }

    case "ERROR": {
      const { error, isPanFetched } = action.payload;
      return { ...state, isAuthenticated: false, isPanFetched, error };
    }
    default: {
      return state;
    }
  }
};

const AuthContext = createContext({
  ...initialState,
  method: "JWT",
  logout: () => {},
  login: () => Promise.resolve(),
  register: () => Promise.resolve(),
  request_otp: () => Promise.resolve(),
});

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);


  const request_otp = async (pan) => {
    axios.post(apiUrl+"/auth/user/request_otp", {"pan":pan}).then(response =>{
      if (response.data["status"] == "Success"){
        const session_id = response.data["result"]["session_id"];
        const masked_mobile = response.data["result"]["masked_mobile"]
        dispatch({ type: "PAN_FETCHED", payload: { user:{session_id:session_id, masked_mobile:masked_mobile} } });
      }
      else{
        dispatch({ type: "ERROR", payload: { error:{isError:true, message: response.data["message"]} } });
      }
    }).catch(error =>{
        if(error.response && error.response.data){
          dispatch({ type: "ERROR", payload: { error:{isError:true, message: error.response.data["message"]} } });
        }
        else{
          dispatch({ type: "ERROR", payload: { error:{isError:true, message: error.message} } });
        }
    });
    
  };


  const login = async (session_id, pan, mobile_otp) => {
    const { data } = await axios.post(apiUrl+"/auth/user/validate_otp", {
      session_id, 
      pan, 
      mobile_otp, 
    }, {
      credentials: "include",
      withCredentials: true
    });

    if(data['status'] == "Success"){
      const result = data['result'];
      dispatch({ 
        type: "LOGIN", 
        payload: { 
          user:{name:result.name, 
            email:result.email,
            pan:result.pan,
            session_id:result.session_id,
            session_user: "clientUser"
          }
        }
      });
    }else{
      console.log(data)
      dispatch({ type: "ERROR", payload: {isPanFetched:false, error:{isError:true, message: data["message"]} } });
    }
  };

  const register = async (email, username, password) => {
    const { data } = await axios.post("/api/auth/register", {
      email,
      username,
      password,
    });

    const { accessToken, user } = data;
    setSession(accessToken);
    dispatch({ type: "REGISTER", payload: { user } });
  };

  const logout = async() => {
    // setSession(null);
    const { data } = await axios.get(apiUrl + "/auth/user/logout",{
      credentials: "include",
      withCredentials: true
    });
    dispatch({ type: "LOGOUT" });
  };

  // console.log("jwt", state);

  useEffect( () => {
      // const accessToken = window.localStorage.getItem("accessToken");
      // setSession(accessToken);
      axios.post(apiUrl+"/auth/user/validate-session", {}, {
        credentials: "include",
        withCredentials: true
      }).then(response => {
        const data = response.data;
        if(data['status'] == "Success"){
          const result = data['result'];
          dispatch({
            type: "AUTH_STATUS",
            payload: { 
              isAuthenticated: result.userLoggedIn, 
              user:{ name:result.name,
                email:result.email,
                pan:result.pan,
                session_id:result.session_id,
                session_user: "clientUser"
              }
            }
          });
        }else {
          dispatch({
            type: "INIT",
            payload: { isAuthenticated: false, user: null },
          });
        }
      }).catch(err =>{
          dispatch({
          type: "INIT",
          payload: { isAuthenticated: false, user: null },
        });
      })
    },
  []);

  if (!state.isInitialised) return <Loading />;

 
  return (
    <AuthContext.Provider value={{ ...state, method: "JWT", login, request_otp, logout, register}}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
